import { render, staticRenderFns } from "./distribute.vue?vue&type=template&id=4b61f463&scoped=true&"
import script from "./distribute.vue?vue&type=script&lang=js&"
export * from "./distribute.vue?vue&type=script&lang=js&"
import style0 from "./distribute.vue?vue&type=style&index=0&id=4b61f463&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61f463",
  null
  
)

export default component.exports